import { useMemo } from 'react';

import { permissions, strings } from 'common';
import { testIds } from 'common/testIds';
import Button from 'components/shared/Button';
import PermissionsGate from 'components/shared/PermissionsGate';
import { usePermissions } from 'hooks';
import { Task, TaskStatus } from 'models';

interface RequestApprovalButtonProps {
  selectedIds: string[];
  tasks: Task[];
  loading: boolean;
  onClick: (status: TaskStatus) => void;
}

const RequestApprovalButton: React.FC<RequestApprovalButtonProps> = (props) => {
  const { selectedIds, tasks, loading, onClick } = props;
  const { hasPermission } = usePermissions();
  const userHasTaskApprovePermissions = hasPermission(
    permissions.INVENTORY_VDP_TASKS_APPROVE
  );

  const disabled = useMemo(() => {
    if (!selectedIds.length) {
      return true;
    }
    return !selectedIds.every((id) => {
      const task = tasks.find((task) => task.id === id);
      return (
        task?.status === 'DRAFT' ||
        task?.status === 'DENIED' ||
        (task?.status === 'COMPLETE' && userHasTaskApprovePermissions)
      );
    });
  }, [selectedIds, tasks, userHasTaskApprovePermissions]);

  return (
    <PermissionsGate permissions={[permissions.INVENTORY_VDP_TASKS_CREATE]}>
      <Button
        data-vas-testing={testIds.ESTIMATE_SECTION_REQUEST_APPROVAL_BUTTON}
        className="FlatTasks-action-button FlatTasks-action-button-request"
        id="request-approval-task-button"
        type="button"
        variant="warning"
        onClick={() => onClick('PENDING_APPROVAL')}
        disabled={disabled}
        loading={loading}
      >
        {strings.REQUEST_APPROVAL}
      </Button>
    </PermissionsGate>
  );
};

export default RequestApprovalButton;
